import { createRouter, createWebHistory } from "vue-router";
import Comics from "../components/Comics.vue";
import Comic from "../components/Comic.vue";
import Read from "../components/Read.vue";
import NotFound from "../components/NotFound.vue";

export const router = createRouter({
    history: createWebHistory(
        BASE_URL.split("/").slice(3).filter(Boolean).join("/"),
    ),
    routes: [
        { path: "/public/*", redirect: "/*" },
        { path: "/", component: Comics, name: "Last Releases" },
        { path: "/comics", component: Comics, name: "All Comics" },
        {
            path: "/manga",
            component: Comics,
            name: "Manga",
            meta: { formatSlug: "manga" },
        },
        {
            path: "/manhwa",
            component: Comics,
            name: "Manhwa",
            meta: { formatSlug: "manhwa" },
        },
        {
            path: "/manhua",
            component: Comics,
            name: "Manhua",
            meta: { formatSlug: "manhua" },
        },
        {
            path: "/webtoon",
            component: Comics,
            name: "Webtoon",
            meta: { formatSlug: "webtoon" },
        },
        {
            path: "/light-novel",
            component: Comics,
            name: "Light Novel",
            meta: { formatSlug: "light-novel" },
        },
        {
            path: "/doujinshi",
            component: Comics,
            name: "Doujinshi",
            meta: { formatSlug: "doujinshi" },
        },
        {
            path: "/one-shot",
            component: Comics,
            name: "One-shot",
            meta: { formatSlug: "one-shot" },
        },
        { path: "/recommended", component: Comics, name: "Recommended" },
        { path: "/comics/:slug", component: Comic },
        {
            path: "/:type(manga|manhwa|manhua|webtoon|light-novel|doujinshi|one-shot)/:slug",
            component: Comic,
        },
        { path: "/targets/:target", component: Comics },
        { path: "/genres/:genre", component: Comics },
        {
            path: "/:type(manga|manhwa|manhua|webtoon|light-novel|doujinshi|one-shot|comics)/:slug/read",
            component: Read,
        },
        {
            path: "/:type(manga|manhwa|manhua|webtoon|light-novel|doujinshi|one-shot|comics)/:slug/read/:lang/:pathMatch(vol/\\d+|ch/\\d+|sub/\\d+)*",
            component: Read,
        },
        { path: "/:pathMatch(.*)*", component: NotFound },
    ],
});
